export default () => (
  <footer className="footer fixed-bottom navbar-inverse" role="contentinfo">
    <div className=" align-center">carvewizard</div>
  </footer>
);
